var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout_container"},[_c('div',{staticClass:"layout_main"},[(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"layout_main_page"}):_vm._e(),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"avue-view"}):_vm._e()],1)],1),(_vm.$store.state.loading)?_c('loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }